// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__OyFKj","row":"Node_row__2l__9","label":"Node_label__21c40","footer":"Node_footer__2Q2bI"};